import { useEffect, useState } from "react"
import { createItemAPI } from "../api/itemsApi"
import authAPI from "../api/authApi"
import "../../main.scss"
import React from "react"
import emailjs from "@emailjs/browser"
import Login from "../user/Login"
import Box from "@mui/system/Box"

function NewTicket() {
  const e = import.meta.env

  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [organization, setOrganization] = useState("")
  const [description, setDescription] = useState("")
  const [error, setError] = useState("")
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const [userExists, setUserExists] = useState(false)
  const [userLoggedIn, setUserLoggedIn] = useState("")
  const [isValid, setIsValid] = useState(false)

  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    setTimeout(() => {
      if (!emailRegex.test(email)) {
        setError("Invalid email address")
      } else {
        setError("")
        checkUserExists(email)
      }
    }, 3000)
  }

  useEffect(() => {
    if (name && email && description) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [email, name, description])

  const checkUserExists = async (email: string): Promise<boolean> => {
    try {
      const result = await authAPI.emailExists(email)
      setUserExists(result.exists)
      return result.exists
    } catch (err) {
      console.error("Failed to check if user exists", err)
      setUserExists(false)
      return false
    }
  }

  const handleOnLogin = (email: string) => {
    setUserLoggedIn(email)
  }

  const handleNewTicket = async () => {
    const ticket = {
      name: name,
      email: email,
      organization: organization,
      description: description,
      status: "open",
      date: Date.now(),
    }
    if (!name || !email || !description) {
      setError("All fields are required")
      return
    }
    try {
      setBusy(true)
      const created = await createItemAPI("tickets", ticket)
      const ticketId = created?.uid || created?.id || ""

      await emailjs.send(
        import.meta.env.VITE_EMAILJS_SERVICE_ID,
        import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
        {
          to_email: "info@doranpauka.com",
          to_name: "Admin",
          from_name: name,
          from_email: email,
          from_organization: organization,
          subject: "New Ticket",
          message: description,
          uid: ticketId,
        },
        import.meta.env.VITE_EMAILJS_USER_ID
      )

      setSent(true)
    } catch (err: any) {
      console.error(err)
      setError(err?.message || "Failed to create ticket")
    } finally {
      setBusy(false)
    }
  }

  const keyPress = (event: any) => {
    if (event.key === "Enter") {
      handleNewTicket()
    }
  }

  const handleEmailChanged = (e: any) => {
    setEmail(e.target.value)
    validateEmail()
  }

  const reset = () => {
    setSent(false)
    setDescription("")
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      {sent ? ( // Show confirmation message if the form is sent
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p style={{ textAlign: "center", margin: "10px" }}>
            Ticket sent successfully!
          </p>
          <button
            onClick={() => reset()}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Send another ticket
          </button>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "600px",
            padding: "20px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          }}
          className="panel"
        >
          <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
            Create ticket
          </h1>
          {error && (
            <p
              style={{
                color: "red",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              {error}
            </p>
          )}
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="textInput"
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyUp={(e) => handleEmailChanged(e)}
            className="textInput"
            required
          />
          {!userExists && userLoggedIn != email && (
            <input
              type="text"
              placeholder="Organization"
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              className="textInput"
            />
          )}
          <textarea
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="textInput"
            rows={10}
            required
          />
          {userExists && userLoggedIn != email && (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "10px",
              }}
            >
              <div className="flex flex-col text-center">
                <div className="mb-3">
                  <h1>Please login here</h1>
                </div>
                <div className="block">
                  <Login
                    defaultEmail={email}
                    onLogin={(email: string) => handleOnLogin(email)}
                  />
                </div>
              </div>
            </Box>
          )}
          {(!userExists || userLoggedIn == email) && (
            <button
              className="buttonSubmit"
              onClick={handleNewTicket}
              disabled={busy || !isValid}
            >
              Create ticket
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default NewTicket
